<template>
    <div class="updateDevice">
      <!-- <h1>Update device</h1> -->

      <v-snackbar v-model="snackbar" :timeout="6000" :color="snackbar_color" location="top" max-height="10cm" max-width="5cm"  multi-line>                  
          {{ snackbar_text }}          
      </v-snackbar>

      <v-card variant="elevated" max-width="1500" style="margin:auto">
        <v-card-actions>
          <v-btn left>Update device</v-btn>
          <v-spacer />
          <v-btn color="red" right @click="$router.go(-1)">CLOSE</v-btn>
        </v-card-actions>
        <v-form v-model="form" @submit.prevent="onSubmit">
        <v-container>
          <v-row>
            <v-col cols="12">            
                <!-- <v-text-field :readonly="loading" :rules="[required]" clearable placeholder="1850024134" label="Device SN*" @change="checkDevice" v-model="device_data.f_deviceSN" ></v-text-field> -->
                <v-text-field :readonly="loading" :rules="[required]" clearable placeholder="1850024134" label="Device SN*" @change="checkDevice"  v-model="device_data.f_deviceSN" ></v-text-field>
            </v-col>

            <v-col cols="12">                                 
                <!-- <v-select
                          :items= "merchants"
                          item-title="merchantName"
                          item-value="merchantId"
                          label="Select Merchant*" 
                          v-model="device_data.f_merchantId"                         
                          :rules="[required]"                          
                ></v-select> -->
                <!-- <v-autocomplete
                  clearable
                  :items= "merchants"
                  item-title="merchantName"
                  item-value="merchantId"
                  label="Select Merchant*" 
                  v-model="device_data.f_merchantId"                         
                  :rules="[required]"
                ></v-autocomplete>  -->
                
                <v-autocomplete
                            v-model="device_data.f_merchantId"
                            :items="merchants" 
                            item-title="merchantName"
                            item-value="id"
                            label="Select Merchant*" 
                            v-model:search="search"
                            placeholder="Start typing..."
                            hide-no-data
                            hide-selected                       
                            no-filter
                            required
                            
                        >                         
                </v-autocomplete>

            </v-col>

            <v-col cols="12">            
             
              
              <v-row class="form-group" v-for="(input, k) in device_data.f_merchantDetails" :key="k">

                <v-col cols="2">            
                    <v-text-field :readonly="loading" :rules="[required]" label="TID*" required v-model="input.tid"></v-text-field>
                </v-col>
                <v-col cols="3">            
                    <v-text-field :readonly="loading" :rules="[required]" label="MID*" required v-model="input.mid"></v-text-field>
                </v-col>
                <v-col cols="2">                                 
                    <v-select
                              :items= "currencies"
                              item-title="currencyName"
                              item-value="currencyCode"
                              label="Select Merchant*" 
                              v-model="input.currencyCode"                       
                              :rules="[required]"                          
                    ></v-select>                                              
                </v-col>
                <v-col cols="2">            
                    <v-text-field :readonly="loading" :rules="[required]" label="CVM limit*" required v-model="input.cvm"></v-text-field>
                </v-col>
                <v-col cols="1">                           
                  <v-btn color="success" icon="mdi-plus" @click="add()" v-show="k == device_data.f_merchantDetails.length - 1"></v-btn> 
                </v-col>
                <v-col cols="1">                             
                  <v-btn color="red" icon="mdi-minus" @click="remove(k)" v-show="k || (!k && device_data.f_merchantDetails.length > 1)"></v-btn>
                   
                </v-col>

              </v-row>

            </v-col> 

            <v-divider></v-divider>
   
            <v-col cols="12">                                 
                        <!-- <v-autocomplete
                          :items="operations"
                          item-title="operationName"
                          item-value="operationId"
                          label="Select Operation*"
                          multiple
                          v-model="device_data.f_operationList"
                          :rules="[required]"
                        ></v-autocomplete> -->
                          
                <p>Select Operation</p>                
                <!-- <p>{{ device_data.f_operationList }}</p> -->
                <v-row>
                  <v-col lg="3" 
                    v-for="it in operations"
                    :key="it.operationId">
                    <v-checkbox
                      v-model="device_data.f_operationList"
                      :label="it.operationName"
                      :value="it.operationName">
                    </v-checkbox>
                  </v-col>
                </v-row>                                
            </v-col>

            <v-divider></v-divider>
            <v-col cols="12"><p>Settelement Config</p></v-col>            

            <!-- <v-col cols="12">                                 
                <v-text-field :readonly="loading" :rules="[required]" clearable label="Settlement name*" v-model="device_data.f_settlement.name"></v-text-field>                                              
            </v-col> -->
            <!-- <v-col cols="6">                                 
                <v-select
                  :items= "['true', 'false']"                                                            
                  label="Select Status*"                         
                  
                  v-model="device_data.f_settlement.status"                         
                ></v-select>                                              
            </v-col>
            <v-col cols="6">                                 
              <v-text-field :readonly="loading" :rules="[required]" label="Settlement time*" v-model="device_data.f_settlement.time" type="time" suffix="PST" ></v-text-field>                                                
            </v-col> -->
            <v-col cols="6">                                 
              <v-text-field :readonly="loading" label="Settlement time*" v-model="device_data.f_stmTime" type="time" suffix="PST" ></v-text-field>                                                
            </v-col>

            <v-col cols="12">                                 
                <!-- <v-autocomplete
                    :items="days"
                    item-title="dayName"
                    item-value="dayId"
                    label="Select Settlement Days*"
                    multiple  
                    v-model="device_data.f_dayList" 
                    :rules="[required]"                       
                ></v-autocomplete> -->
                
                <p>Select Days</p>
                <v-row >
                  <v-col lg="3" 
                    v-for="it in days"
                    :key="it.dayId">
                    <v-checkbox
                      v-model="device_data.f_dayList"
                      :label="it.dayName"
                      :value="it.dayId">
                    </v-checkbox>
                  </v-col>
                </v-row>

            </v-col>

            <v-divider></v-divider>

            <v-col cols="3">            
                <v-text-field :readonly="loading" clearable label="Number of Receipt" required v-model="device_data.f_receiptNumber"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">                                 
              <v-select
                :items= "['true', 'false']"                          
                label="Dual Currency Status"                      
                v-model="device_data.f_isDualCurrency"
              ></v-select>                                              
            </v-col> 
            <v-col cols="12" sm="6">                                 
              <v-select
                :items= "['true', 'false']"                          
                label="Download Status"                       
                v-model="device_data.f_isDownloadEnable"
              ></v-select>                                              
            </v-col> 

            <v-divider></v-divider>


          </v-row> 
          
          <v-row><small>* indicates required field</small></v-row>
           
          <v-row justify="center">
            <v-col cols="auto">
              <v-btn :disabled="!form" :loading="loading" color="success" type="submit" @click="updateDevice">UPDATE</v-btn>
            </v-col>

            <v-col cols="auto">
              <v-btn @click="this.$router.push({name:'DeviceDetails'})">Cancel</v-btn>              
            </v-col>            
          </v-row>
          
           
        </v-container>  
        
      </v-form>
       
    </v-card>
    
    </div>
    
  </template>
  
  <script>
  import axios from 'axios'  
  export default {
    name: 'updateDevice',
    components: { 
      
    },
    props: {
      msg: String,
      //name: String,      
    },
    data(){
      return {
        //name: '',       
        devices: [],  //used
        merchants:[],
        operations: [],
        days: [{dayId: "Monday", dayName: "Monday"}, {dayId: "Tuesday", dayName: "Tuesday"}, {dayId: "Wednesday", dayName: "Wednesday"}, {dayId: "Thursday", dayName: "Thursday"}, {dayId: "Friday", dayName: "Friday"}, {dayId: "Saturday", dayName: "Saturday"}, {dayId: "Sunday", dayName: "Sunday"}],
        currencies: [],  
        
        dialog: false,
        //dialog_update: false,
        //dialog_delete: false,

        //dialog:false,

        device_data:{  //used
          f_deviceSN: '',
          f_merchantId: '',
          f_merchantDetails: [{tid: '', mid: '', cvm: '', currencyId: ''}],
          f_operationList: [],
          /* f_settlement : {            
            name: '',
            status: '',
            time: ''
          }, */
          f_dateCreated: '',
          f_dayList: [],
          f_stmTime: '',
          f_createdByUserEmail: '',
          f_dateUpdated: '',
          f_updatedByUserEmail: '',
          f_receiptNumber: 2,
          f_isDualCurrency: false,
          f_isDownloadEnable: true,
          
        },

        deviceId: '',  
        existing_deviceSN: '',  
          
        

        inputs:[
          {tid: '', mid: '', cvm: ''}
        ],

        form: false,
        loading: false,
        exist: false,

        //FOR USER DATA
        user_roles: '',
        user_org: '',
        user_permissions:[],

        //snackbar
        snackbar: false,
        snackbar_text: '',
        snackbar_color: '',
        

        


      }
    },

    created () {
      //this.initialize()
    },


    watch:{        

        //auto-complete
        search(newSearch) {
          if (newSearch.length >= 2) {
            this.searchMerchant(newSearch);
          } else {
            this.merchants = [];
          }
        },
        
    },

    methods:{      

      onSubmit () {
        //if (!this.form) return
        //this.loading = true
        //setTimeout(() => (this.loading = false), 2000)
        
      },

      required (v) {
        return !!v || 'Field is required'
      },

      device_check(v) {                
          //this.checkDevice(v)
          if(this.existing_deviceSN != v){
            //this.checkDevice(v) 
            // console.log("HAPPEN", "HAPPENED")           
            if(this.exist) return true
            //if(this.exist) return 'Device exist'
            return 'Device exist'            
          }
          
          // if(this.exist) return true
          // return 'Device exist'
      },
      
      add(){
          //this.inputs.push({name: ''});
          this.device_data.f_merchantDetails.push({tid: '', mid: '', cvm: '', currencyId: ''});          
      },

      remove(index){
         // this.inputs.splice(index, 1);
          this.device_data.f_merchantDetails.splice(index, 1);
      },

      show_toast(status, color, text){
        this.snackbar = status
        this.snackbar_color = color
        this.snackbar_text = text;
      },

      
      
      requests_handler2() {        
        // console.log("id", this.$route.params.id);
        // let newId;
        // console.log("NAME", this.name);
        // if(this.name != null || this.name != ''){
        //     newId = this.name;
        // }
        // else{newId = this.$route.params.id}
        // console.log("id", newId);

        axios.all([            
            axios.get(window.baseurl +"devices/"+ this.$route.params.id , 
              {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
            ) ,
            
            //axios.get(window.baseurl+""+"merchants/"+this.orgId + "/org" , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get("accessToken")}} ),

            axios.get(window.baseurl+""+"currencies" , 
              {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
            ),
            axios.get(window.baseurl+""+"operations/org/"+this.orgId  , 
              {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
            ),

            //axios.get(window.baseurl+""+"sDays/list" , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get("accessToken")}})           
        ])
        .then(axios.spread((dev_response, cur_response, ope_response) => {              
              
              // console.log("data1", dev_response.data);           
              // console.log("data1", mer_response.data);
              // console.log("data2", cur_response.data);
              // console.log("data3", ope_response.data);
              // console.log("data4", days_response.data);

              //get data for selected id and display data in for dialog
              if(dev_response.status == 200){                    
                //this.acquirer_response = acquirer_response.data,
                // console.log("devices Data", this.dev_response)
                this.device_data.f_deviceSN = dev_response.data.deviceSN
                this.device_data.f_merchantId = dev_response.data.merchant.id 
                this.merchants = [];
                let merchant_name =  dev_response.data.merchant.merchantName + " - "+ dev_response.data.merchant.merchantAddress;                                              
                this.merchants.push({ id: dev_response.data.merchant.id, merchantName: merchant_name }); 
                
                this.existing_deviceSN = dev_response.data.deviceSN    //to record SN 

                let i = 0;
                this.device_data.f_merchantDetails = [];   //remove all items from array
                for(i=0; i<dev_response.data.merchantDetails.length; i++){                                                    
                    this.device_data.f_merchantDetails.push({ tid: dev_response.data.merchantDetails[i].tid, mid: dev_response.data.merchantDetails[i].mid, cvm: dev_response.data.merchantDetails[i].cvm, currencyCode: dev_response.data.merchantDetails[i].currency.currencyCode });                          
                    console.log("Merchantdetails", this.device_data.f_merchantDetails)
                         
                } 

                //this.device_data.f_merchantDetails = dev_response.data.merchantDetails

                this.device_data.f_operationList = [];   //remove all items from array                
                if(dev_response.data.allowedOperations != null){
                  let str = dev_response.data.allowedOperations                ;
                  let str_array = str.split(',');
                  for(let i = 0; i < str_array.length; i++) {
                    // Trim the excess whitespace.
                    str_array[i] = str_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
                    // Add additional code here, such as:
                    //alert(str_array[i]);
                    // console.log("operation", str_array[i]);
                    this.device_data.f_operationList.push(str_array[i] );
                  }
                }

                
                this.device_data.f_stmTime = dev_response.data.stmTime
                this.device_data.f_receiptNumber = dev_response.data.receiptNumber
                this.device_data.f_isDualCurrency = dev_response.data.dualCurrency
                this.device_data.f_isDownloadEnable = dev_response.data.downloadEnable 


                this.device_data.f_dayList = [];   //remove all items from array                               
                if(dev_response.data.settleDays != null){                
                  let str = dev_response.data.settleDays;
                  let str_array = str.split(',');
                  for(let i = 0; i < str_array.length; i++) {
                    // Trim the excess whitespace.
                    str_array[i] = str_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
                    // Add additional code here, such as:
                    //alert(str_array[i]);
                    // console.log("operation", str_array[i]);
                    this.device_data.f_dayList.push(str_array[i] );
                  }
                }
                            
                
              }
              
              /* if(mer_response.status == 200){  
                  if(mer_response.data != null && mer_response.data.length > 0){
                      let i = 0;
                      this.merchants = [];   //remove all items from array
                      for(i=0; i<mer_response.data.length; i++){   
                         let merchant_name =   mer_response.data[i].merchantName + " - "+ mer_response.data[i].merchantAddress;                                               
                          //this.merchants.push({ merchantId: mer_response.data[i].merchantId, merchantName: mer_response.data[i].merchantName }); 
                          this.merchants.push({ merchantId: mer_response.data[i].merchantId, merchantName: merchant_name });                          
                          console.log("merchants", this.merchants)
                         
                      }                      
                  }                  
              }  */
              
              if(cur_response.status == 200){  
                  if(cur_response.data.records != null && cur_response.data.records.length > 0){
                      let i = 0;
                      this.currencies = [];   //remove all items from array
                      for(i=0; i<cur_response.data.records.length; i++){                                                    
                          this.currencies.push({ currencyCode: cur_response.data.records[i].currencyCode, currencyName: cur_response.data.records[i].currencyName });                          
                          //console.log("Currencies", this.currencies)
                         
                      }                      
                  }                  
              }  

              if(ope_response.status == 200){  
                  if(ope_response.data.records != null && ope_response.data.records.length > 0){
                      let i = 0;
                      this.operations = [];   //remove all items from array
                      for(i=0; i<ope_response.data.records.length; i++){                                                    
                          this.operations.push({ operationId: ope_response.data.records[i].id, operationName: ope_response.data.records[i].operationName });                          
                          // console.log("operations", this.operations)
                         
                      }                      
                  }                  
              } 
              
              
              
        }))

      }, //end of requests_handler 2 method

      
      async checkDevice(){ 

        this.exist = false;
        
        if(this.existing_deviceSN != this.device_data.f_deviceSN){
        //if(this.existing_deviceSN != sn){  
            // console.log("NOT EQUAL", this.device_data.f_deviceSN)
            //console.log("NOT EQUAL", sn)            

            try {
              let result_SN = await axios.get(window.baseurl+""+"devices/sn/" + this.device_data.f_deviceSN , 
                {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
              )
              //let result_SN = await axios.get(window.baseurl+""+"device/get/"+""+sn+""+"/serial_number")
              //  console.log("RESPONSE", result_SN)
              if (result_SN.status == 200) {
                //alert("device exist");
                //this.show_toast(true, "warning", "Device exist"); 
                this.$root.vtoast.showError({message: this.device_data.f_deviceSN + " Already exist"})               
                // console.log("EXIST", "device exist")
                this.exist = true; 
                this.form = true               
                //console.log("EXIST value 1", this.exist)
              }   
            }
            catch (err) {
              // console.log("EXIST", "device does not exist")
              // console.log(err.response.data);
              
            }
        }
        else{
          
            this.exist = false;
        }

      },

      async updateDevice(){
          // console.log("existing device", this.existing_deviceSN);
          // console.log("device SN  in form", this.device_data.f_deviceSN);

          //check if device exist in database before submitting data
          /* if(this.existing_deviceSN != this.device_data.f_deviceSN){
            console.log(" NOT EQUAL", this.device_data.f_deviceSN)
            try {
              let result_SN = await axios.get(window.baseurl+""+"device/get/"+""+this.device_data.f_deviceSN+""+"/serial_number" , 
                {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
              )
               console.log("RESPONSE", result_SN)
              if (result_SN.status == 200) {
                //alert("device exist");
                this.show_toast(true, "warning", "Device exist");                
                console.log("EXIST", "device exist")
                this.exist = true;
                console.log("EXIST value 1", this.exist)
              }   
            }
            catch (err) {
              console.log("EXIST", "device does exist")
              console.log(err.response.data);
              if(err.response.data.message == "No value present" && err.response.data.status == 500){
                this.exist = false;
                console.log("EXIST value 2", this.exist)
              }
            } 
          }
          else{ 
              console.log("EQUAL", "true")          
              this.exist = false;
          } */

          //if exist do not submit else submit
          //this.checkDevice();
          if(this.exist){
            // console.log("EXIST112", this.exist);
            //this.show_toast(true, "warning", "Device exist");
            this.$root.vtoast.showError({message: 'Device exist'})            
          }
          else{
            // console.log("EXIST113", this.exist)
            // console.log("form data2", this.device_data)
            // console.log("form data111", this.userEmail)
            try {
              let result = await axios.put(window.baseurl+""+"devices/" +this.$route.params.id, {
                deviceSN:this.device_data.f_deviceSN,
                merchant_id:this.device_data.f_merchantId,
                merchantDetails:this.device_data.f_merchantDetails,
                //allowedOperations:this.device_data.f_operationList,
                allowedOperations:this.device_data.f_operationList.join(),
                
                stmTime:this.device_data.f_stmTime,
                //settleDays:this.device_data.f_dayList,
                settleDays:this.device_data.f_dayList.join(),
                receiptNumber:this.device_data.f_receiptNumber,
                dualCurrency:this.device_data.f_isDualCurrency,
                downloadEnable:this.device_data.f_isDownloadEnable,                
                updatedBy:this.userEmail,
                                        
                    
              },
              {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
              );          
              if (result.status == 200) {
                  //alert("successfull");
                  //this.show_toast(true, "success", "Successful");
                  this.$root.vtoast.show({message: result.data.message})                  
                  window.setInterval(() => {
                    //this.$router.push({name:'Devices2'})
                    //this.$router.push({name:'Devices'})
                    //this.$router.push({name:'DeviceDetails'})
                    //this.$router.go(-1)

                    //this.$emit("reload")
                    
                  }, this.waiting_time)              
                  
              }
            }catch (err) {              
              // console.log(err.response.data);
              this.show_toast(true, "warning", err.response.message);              
              window.setInterval(() => {
                //this.$router.push({name:'Devices2'})
                //this.$router.push({name:'Devices'})
                //this.$router.push({name:'DeviceDetails'})

                //this.$router.go(-1)
                
              }, this.waiting_time)
              
            }
        }
            

      },


      async searchMerchant(search) {    
        // console.log("in searchMerchant", search);
        let result;

        this.mcc = [];
        //this.loading = true;
        //let page2 = this.page - 1;
        if (search.length < 2) {
          this.merchants = [];
          return;
        } 
        try{
          if(this.global_permissions.includes("ROLE_STAFF_ADMIN", "ROLE_STAFF_USER")){            
            result = await axios.get(window.baseurl+"merchants/search", {
              params: { search: search },
              headers: { 'Authorization': 'Bearer ' + this.accessToken  }            
            })            
            // console.log("activity_search_object", result);
            this.merchants = result.data.records;  
            
          } 

          else if(this.global_permissions.includes("ROLE_USER_ADMIN", "ROLE_MOD_MERCHANT")){            
            result = await axios.get(window.baseurl+"merchants/org/search/" + this.orgId, {
              params: { search: search },
              headers: { 'Authorization': 'Bearer ' + this.accessToken  }            
            })            
            // console.log("activity_search_object", result);
            this.merchants = result.data.records;  
            
          } 
            
        } 
        catch (error){            
            this.show_toast(true, "warning", error.message);            
        }   
      },


      

    },
    
    async mounted(){

      this.checkTokenExpiry();
      
      this.requests_handler2()
 

    }

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  </style>
  